module.exports = __webpack_public_path__ + "media/images/bio4d-16aa133d.svg";